export enum Tab {
  General = '1',
  Access = '2',
  State = '3',
}
